import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <nav className="footer__nav">
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms & Conditions</Link>
        </nav>
        <p className="footer__copy">
          &copy; {new Date().getFullYear()} Stage Door Weddings. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
